<template>
  <div>
    <app-cells position="between">
      <h1 class="title">EFD Purchases</h1>
      <app-button @click.native="onShowExportModal" v-if="is_general_manager">Export</app-button>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view :legal-entities="legal_entity_options" />
    </transition>
    <modal
      name="exportModal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('exportModal')" class="popup__close" type="button"></button>
        <div class="popup__title">Export</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckFormExport">
            <app-form-group label="Date Range" required>
              <app-date-picker
                v-model="form_export.period"
                range
                :clearable="false"
                placeholder="Date Range"
                :error="$v.form_export.period.$error"
              />
              <template #error>
                <div v-if="$v.form_export.period.$dirty && !$v.form_export.period.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Legal Entity" required>
              <app-select
                v-model="form_export.legal_entity"
                :options="legal_entity_options"
                :reduce="item => item.code"
                :clearable="false"
                label="short_name"
                placeholder="Legal Entity"
                :error="$v.form_export.legal_entity.$error"
              />
              <template #error>
                <div v-if="$v.form_export.legal_entity.$dirty && !$v.form_export.legal_entity.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Supplier">
              <app-select
                v-model="form_export.supplier"
                @search="onSupplierSearch"
                :options="supplier_options"
                :filterBy="() => true"
                :display-field="option => `${option.trade_name === option.legal_name ? option.trade_name : `${option.trade_name} (${option.legal_name})`}`"
                label="trade_name"
                placeholder="Supplier"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="submitExport" :disabled="$v.form_export.$error">Export</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { required } from 'vuelidate/lib/validators'
import { getAdministrativeLegalEntities, getAdministrativeSuppliers, getFinanceSupplierEfdReceiptExport } from '@/http'
import { format, parse } from 'date-fns'
import debounce from 'lodash/debounce'

export default {
  name: 'FinanceEFDPurchases',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-efd-receipts', label: 'EFD Receipts'},
        { name: 'finance-vat-records', label: 'VAT Records'},
        { name: 'finance-tra-records', label: 'TRA Records'},
      ],
      form_export: {},
      legal_entity_options: [],
      supplier_options: [],
    }
  },
  validations: {
    form_export: {
      legal_entity: { required },
      period: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  created() {
    getAdministrativeLegalEntities().then(response => { this.legal_entity_options = response.data })
  },
  methods: {
    onShowExportModal() {
      this.form_export = {}
      this.$v.form_export.$reset()
      this.$modal.show('exportModal')
    },
    onCheckFormExport() {
      this.$v.form_export.$touch()
      if (this.$v.form_export.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendFormExport()
      }
    },
    sendFormExport() {
      this.$refs.submitExport.preload = true
      const data = {
        legal_entity: this.form_export.legal_entity,
        date_after: this.form_export.period[0],
        date_before: this.form_export.period[1],
      }
      if (this.form_export.supplier) data.supplier = this.form_export.supplier.id
      getFinanceSupplierEfdReceiptExport(data)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `EFD Purchases export ${this.dateFormat(this.form_export.period[0])}-${this.dateFormat(this.form_export.period[1])}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.$modal.hide('exportModal')
        })
        .catch(() => { this.$refs.submitExport.preload = false })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
